/*
  Lisen – brandbåndene (Lones idé, Claude 22. sep. 2026)
  Hører til snippets/lisen-brandbaand.liquid og assets/lisen-brandbaand.css.

  HVERT BÅND ER SIN EGEN SEKTION: Brandbånd 1 (Populære), 2 (Egne brands),
  3 (Øvrige) og én med alle.

  DERFOR KØRER SCRIPTET I TO OMGANGE. "Øvrige" betyder "alle undtagen dem,
  de andre bånd viser", og det kan Liquid ikke vide, for en sektion kan ikke
  se en anden sektions indstillinger. Første omgang noterer, hvad
  liste-båndene har med; anden omgang bygger, og øvrige springer dem over.

  LUFTEN ER ELASTISK (Lone, 23. sep. 2026). Første version gentog bare
  logoerne, til båndet fyldte skærmen. På en 2000 px skærm betyder seks
  logoer, at man ser MARTA tre steder på én gang – det ligner en fejl, ikke
  et design. strakLuften() spreder dem derfor ud, så sættet fylder mindst én
  skærmbredde, før der klones. Så møder man først det samme logo igen, når
  det første er gledet ud i den anden side. Luften i temaindstillingerne er
  altså et MINIMUM – på en bred skærm bliver der mere.

  DEN RUNDER OP, IKKE NED. Rundede den ned, blev båndet nogle få pixels
  smallere end skærmen, og så lagde næste trin en hel ekstra omgang på – og
  gentagelsen var tilbage. To pixels for lidt kostede et dobbelt logo.

  RESTEN, PR. BÅND:
    1. Brandene hentes ud af <template>, så browseren ikke har hentet et
       eneste logo endnu.
    2. Båndet blandes og skæres ned til det ønskede antal.
    3. Adressen flyttes fra data-src til src – først nu hentes billederne,
       og kun de valgte. De 65 filer vejer 846 KB tilsammen.
    4. Vi venter til billederne er målbare, spreder luften, gentager til
       båndet fylder skærmen, og dublerer så hele indholdet én gang.
    5. Tiden for en omgang regnes ud, og CSS kører bevægelsen.

  DUBLERINGEN ER HELE TRICKET. CSS skubber fra 0 til -50 %. Når indholdet
  står præcis to gange, ser billedet halvvejs ud nøjagtigt som ved start, og
  springet tilbage er usynligt. Kloner man et andet antal gange, hopper det.

  DERFOR VENTER VI PÅ BILLEDERNE. Bredden kan først måles, når logoerne har
  en størrelse. Et brand uden logofil fjerner sig selv i samme øjeblik (se
  onerror i snippet'en), så vi måler også først, når det er væk.

  BLANDINGEN SKER HER OG IKKE I LIQUID, fordi Shopify gemmer den færdige side
  og viser den samme til alle.

  FLERE BÅND PR. SIDE betyder, at filen indlæses flere gange. Vagten nedenfor
  gør, at kun den første kører. Den må ikke hedde det samme som et id i
  siden – browseren laver selv globale variabler ud af id'er, og så stopper
  scriptet sig selv uden en eneste fejlmeddelelse.
*/
(function () {
  'use strict';

  if (window.LisenBrandbaandStyring) return;
  window.LisenBrandbaandStyring = true;

  var MAKS_LUFT = 200;

  var stille = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bland(liste) {
    for (var i = liste.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = liste[i]; liste[i] = liste[j]; liste[j] = t;
    }
    return liste;
  }

  function felterI(baand) {
    var t = baand.querySelector('template[data-lisen-kilde]');
    if (!t) return [];
    return Array.prototype.slice.call(t.content.querySelectorAll('[data-lisen-felt]'));
  }

  function faerdigt(img) {
    return new Promise(function (ok) {
      if (img.complete) { ok(); return; }
      img.addEventListener('load', ok, { once: true });
      img.addEventListener('error', ok, { once: true });
      setTimeout(ok, 4000);
    });
  }

  function klon(node) {
    var k = node.cloneNode(true);
    k.setAttribute('aria-hidden', 'true');
    k.setAttribute('tabindex', '-1');
    return k;
  }

  // Spreder logoerne, så sættet fylder mindst én skærmbredde – se toppen.
  function strakLuften(baand, rulle, grund, plads) {
    var n = grund.length;
    if (!n) return;
    var luft = parseFloat(getComputedStyle(grund[0]).paddingLeft) || 0;
    var bredde = rulle.scrollWidth;
    if (bredde >= plads) return;
    var blaek = bredde - n * 2 * luft;
    var ny = Math.min(MAKS_LUFT, Math.ceil((plads - blaek) / (2 * n)));
    if (ny > luft) baand.style.setProperty('--luft', ny + 'px');
  }

  function fyldOgStart(baand, fart) {
    var spor = baand.querySelector('.lisen-baand__spor');
    var rulle = spor && spor.querySelector('.lisen-baand__rulle');
    if (!rulle) return;

    var grund = Array.prototype.slice.call(rulle.children);
    if (!grund.length) { baand.hidden = true; return; }

    var plads = spor.clientWidth || 1;
    strakLuften(baand, rulle, grund, plads);

    var grundBredde = rulle.scrollWidth;
    if (!grundBredde) return;

    var gange = Math.ceil(plads / grundBredde) - 1;
    for (var g = 0; g < gange; g++) {
      for (var n = 0; n < grund.length; n++) rulle.appendChild(klon(grund[n]));
    }

    var helt = Array.prototype.slice.call(rulle.children);
    for (var h = 0; h < helt.length; h++) rulle.appendChild(klon(helt[h]));

    var halv = rulle.scrollWidth / 2;
    rulle.style.setProperty('--tid', Math.max(10, Math.round(halv / fart)) + 's');
    baand.setAttribute('data-klar', '');
  }

  function opsaet(baand, taget) {
    if (baand.getAttribute('data-lisen-gjort')) return;
    baand.setAttribute('data-lisen-gjort', 'ja');

    var rulle = baand.querySelector('.lisen-baand__rulle');
    if (!rulle) return;

    var udvalg = baand.getAttribute('data-udvalg') || 'alle';
    var antal = parseInt(baand.getAttribute('data-antal'), 10) || 12;
    var fart = parseFloat(baand.getAttribute('data-fart')) || 22;
    var retning = baand.getAttribute('data-retning') || 'venstre';

    var felter = felterI(baand);
    if (udvalg === 'oevrige') {
      felter = felter.filter(function (f) { return !taget[f.getAttribute('data-mrk')]; });
    }

    bland(felter);
    felter = felter.slice(0, antal);

    if (!felter.length) { baand.hidden = true; return; }

    var valgte = [];
    for (var i = 0; i < felter.length; i++) {
      var k = document.importNode(felter[i], true);
      var im = k.querySelector('img');
      if (im && im.getAttribute('data-src')) {
        im.setAttribute('src', im.getAttribute('data-src'));
        im.removeAttribute('data-src');
        valgte.push(im);
      }
      rulle.appendChild(k);
    }

    if (stille || retning === 'stille') return;

    Promise.all(valgte.map(faerdigt)).then(function () {
      fyldOgStart(baand, fart);
    });
  }

  function start() {
    var baand = Array.prototype.slice.call(document.querySelectorAll('[data-lisen-baand]'));
    if (!baand.length) return;

    var taget = {};
    baand.forEach(function (b) {
      if (b.getAttribute('data-udvalg') !== 'liste') return;
      felterI(b).forEach(function (f) { taget[f.getAttribute('data-mrk')] = true; });
    });

    baand.forEach(function (b) { opsaet(b, taget); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
